import { ActivityScope } from './types'

/** The request headers of the activity contract (backend: ActivityHistoryConsts.Headers). */
export const ACTIVITY_HEADERS = {
  id: 'X-Activity-Id',
  name: 'X-Activity-Name',
  subjectType: 'X-Activity-Subject-Type',
  subjectId: 'X-Activity-Subject-Id',
} as const

/** The backend's rule for X-Activity-Name: 2 to 5 PascalCase segments, e.g. "Ime.Appointment.Save". */
export const ACTIVITY_NAME_PATTERN =
  /^[A-Z][A-Za-z0-9]*(\.[A-Z][A-Za-z0-9]*){1,4}$/

export const ACTIVITY_NAME_MAX_LENGTH = 128

export const isValidActivityName = (name: unknown): name is string =>
  typeof name === 'string' &&
  name.length <= ACTIVITY_NAME_MAX_LENGTH &&
  ACTIVITY_NAME_PATTERN.test(name)

/** The headers a request made during `scope` carries. */
export const buildActivityHeaders = (
  scope: ActivityScope
): Record<string, string> => {
  const headers: Record<string, string> = {
    [ACTIVITY_HEADERS.id]: scope.id,
    [ACTIVITY_HEADERS.name]: scope.name,
    [ACTIVITY_HEADERS.subjectType]: scope.subject.type,
  }
  if (scope.subject.id) {
    headers[ACTIVITY_HEADERS.subjectId] = String(scope.subject.id)
  }
  return headers
}

/** A uuid v4 (crypto.randomUUID where available, with fallbacks for older browsers and jsdom). */
export const newActivityId = (): string => {
  const cryptoApi: Crypto | undefined =
    typeof globalThis !== 'undefined' ? globalThis.crypto : undefined
  if (cryptoApi && typeof cryptoApi.randomUUID === 'function') {
    return cryptoApi.randomUUID()
  }
  const bytes = new Uint8Array(16)
  if (cryptoApi && typeof cryptoApi.getRandomValues === 'function') {
    cryptoApi.getRandomValues(bytes)
  } else {
    for (let i = 0; i < bytes.length; i++) {
      bytes[i] = Math.floor(Math.random() * 256)
    }
  }
  bytes[6] = (bytes[6] & 0x0f) | 0x40
  bytes[8] = (bytes[8] & 0x3f) | 0x80
  const hex = Array.from(bytes, b => b.toString(16).padStart(2, '0')).join('')
  return [
    hex.slice(0, 8),
    hex.slice(8, 12),
    hex.slice(12, 16),
    hex.slice(16, 20),
    hex.slice(20),
  ].join('-')
}
